import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import { api } from "@/lib/api";

export function MemberOfferBanner({ user }) {
  const [o, setO] = useState(null);
  useEffect(() => {
    const pull = () => api.get("/member-offer").then(({ data }) => setO(data)).catch(() => {});
    pull();
    const t = setInterval(pull, 30000);
    return () => clearInterval(t);
  }, []);
  const mine = user?.member_offer_until && new Date(user.member_offer_until) > new Date() && user.membership_tier === "premium" ? user.member_offer_until : null;
  if (!o || (!mine && o.left <= 0)) return null;
  return (
    <div data-testid="member-offer-banner" className="max-w-3xl mx-auto mb-10 rounded-3xl border border-gold/40 bg-gradient-to-br from-wine/30 to-surface p-7 text-center">
      <p className="text-[10px] uppercase tracking-[0.3em] text-gold flex items-center justify-center gap-2"><Crown size={13} /> Founding members offer</p>
      {mine ? (
        <p data-testid="member-offer-claimed" className="font-display text-3xl font-light mt-3">Your free Premium runs until {new Date(mine).toLocaleDateString()}</p>
      ) : (
        <>
          <p className="font-display text-3xl font-light mt-3">Activate Basic, get Premium free for {Math.round(o.days / 30)} month</p>
          <p data-testid="member-offer-left" className="text-sm text-text-muted mt-2"><span className="text-gold">{o.left}</span> of {o.total} spots left. Your spot is locked in with your first Basic payment, once the free trial ends.</p>
          <div className="h-1.5 rounded-full bg-white/10 overflow-hidden max-w-xs mx-auto mt-4">
            <div className="h-full bg-gold transition-[width] duration-700" style={{ width: `${(o.claimed / o.total) * 100}%` }} />
          </div>
        </>
      )}
    </div>
  );
}
